import PageTitle from "../../components/custom/components/PageTitle";
import AdminLayout from "../../components/custom/layouts/AdminLayout";

const CultureSetting = () => {
    return <AdminLayout>
        <PageTitle
            title='Culture Setting'
        />
        {/* <div className="card">
       <div className="card-body">
           
       </div>
   </div> */}
    </AdminLayout>
}
export default CultureSetting;      
